document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance;

  function initSwiper() {
    if (window.innerWidth <= 900 && !swiperInstance) {
      swiperInstance = new Swiper(".steps-section.swiper", {
        slidesPerView: "auto",
        spaceBetween: 16,
        freeMode: true,
        centeredSlides: false, // додано: відключає центрування
        initialSlide: 0, // починаємо з першого слайда
      });
    } else if (window.innerWidth > 900 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  initSwiper();

  window.addEventListener("resize", function () {
    initSwiper();
  });
});
